import React from 'react'

const StoreFront = () => {
  return <div>StoreFront</div>
}

export default StoreFront
